import { ViewController, ButtonClickEvent } from "@gaming/srvg-classes-core";
import { OverlayButtonbarView } from "../../View/OverlayButtonbarView";
import { OverlayContainerContainerViewController } from "./OverlayContainerContainerViewController";

export class OverlayButtonbarViewController extends ViewController {
    overlayButtonbarView: OverlayButtonbarView;

    constructor( options ) {
        options = options || {};
        options.name = options.name || 'overlayButtonbarViewController';
        options.view = options.overlayButtonbarView|| null;
        super(options);

        this.overlayButtonbarView = options.overlayButtonbarView || null;
        this.overlayButtonbarView.setDelegate( this );

        this.generatedEvents.push( ButtonClickEvent );
    }

    handleButtonClickEvent( event:ButtonClickEvent, provider ) {
        this.triggerEvent( event );

        if(event.button.selector == '#tableButton') {
            // controller containing groupTablesGalleryViewController
            var parent = <OverlayContainerContainerViewController>this.parentViewController;
            // pager we want to modify
            var pager = parent.groupTablesGalleryViewController.galleryView.pagerView;
            pager.selectIndex(parent.groupTablesGalleryViewController.pairOfGroupsToBeHighlighted);
        }
    }
}